import { PlusOutlined, RedoOutlined, SearchOutlined } from '@ant-design/icons'
import {
  Alert,
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Switch,
  Table
} from 'antd'
import {
  getDataGroupORCategoryV2,
  getResultCompanyV2,
  getTreeV3,
  postDataGroupORCategory,
  putDataGroupORCategory,
  saveStrategicImperative,
  updateStrategicImperative
} from 'api/Admin/group'
import DeleteProjectgroup from 'common/Management/delete'
import { getCookie } from 'helper/cookie'
import lang from 'lang/en'
import { toUpper } from 'lodash'
import moment from 'moment'
import {
  useContext,
  useEffect,
  useState
} from 'react'
import styled from 'styled-components'
import iconInitialState from '../../../icons/createproject/supportneed.svg'
import Tree from '../Tree/Company/TreeProjectgroup'
import FilterSearchTree from './FilterSearchTree'

//checkrole
import { CounterContext } from 'redux/Golbalvalues'

const GroupContainer = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`
const initialState = {
  data_group: [],
  data_category: [],
  data_company: [],
  data_tree: [],
  data_select: [],
  data_index: [],
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    // showSizeChanger: true,
    showQuickJumper: 1,
    // showTotal: (total, range) => showToalPagination(total, range),
  },
}
const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}

const compareText = (a, b) => String(a ?? '').localeCompare(String(b ?? ''))

let text_title_drawer = ''
let case_from = ''
let case_api_call = ''
let companyID_getfirstshot = 0
const Group = (props) => {
  const Option = Select.Option
  const { today, infoUser } = props
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const [form1] = Form.useForm()
  const [form2] = Form.useForm()
  const [form3] = Form.useForm()
  const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY']

  //datatree //datatree //datatree //datatree
  const [companyID, setCompanyID] = useState()
  const [level, setLevel] = useState(1)
  const [level_ID, setLevel_ID] = useState(0)
  const [checkByID, setCheckByID] = useState()
  const [checkChangeTable, setCheckChangeTable] = useState(0)
  //datatree //datatree //datatree //datatree
  const [resultscompany, setResultscompany] = useState(initialState.data_company)
  const [dataproject, setDataproject] = useState(initialState.data_group)
  const [tree, setTree] = useState(initialState.data_tree)
  const [drawer, setDrawer] = useState(false)
  const [eventdrawer, setEventdrawer] = useState(false)
  const [selecttable, setSelecttable] = useState('group')
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [stateBtnDelete, setStateBtnDelete] = useState()
  const [dataselect, setDataSelect] = useState(initialState.data_select)
  const [companyCallDelete, setCompanyCallDelete] = useState()
  const [groupcodelist, setGroupcodelist] = useState([])
  const [pagination, setPagination] = useState(initialState.pagination)
  const [errormessage, setErrormessage] = useState(true)
  const [searchText, setSearchText] = useState('')
  const [searchedColumn, setSearchedColumn] = useState('')
  const [statepage, setStatepage] = useState(true)
  const [stateID, setStateID] = useState([])
  const [stateData, setStateData] = useState([])
  const [wordERR, setWordERR] = useState('')
  const [groupdata, setGroupData] = useState([])
  const [catdata, setCatData] = useState([])
  const [stateModal, setStateModal] = useState('')
  const [switchValue, setSwitchValue] = useState(true)
  // State for Strategic Imperative form values
  const [imperativeForm, setImperativeForm] = useState({
    imperative_code: '',
    local_imperative_name: '',
    english_imperative_name: '',
  })
  //checkrole
  const { adminPermission } = useContext(CounterContext)
  //check permission
  const [disablePage, setDisablePage] = useState(false)
  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const [selectedId, setSelectedId] = useState(0)
  const [filteredCompanies, setFilteredCompanies] = useState([])
  const [filteredTreeCompany, setFilteredTreeCompany] = useState([])

  const roleUser = getCookie('roleUser')
  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 12) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y',
            read: item.read == 'Y',
            update: item.update == 'Y',
            delete: item.delete == 'Y',
          }))
        }
      })
    }
  }, [adminPermission])

  // useEffect for filteredCompanies
  useEffect(() => {
    if (filteredCompanies.length > 0) {
      const filteredTree = tree.filter((item) => filteredCompanies.includes(item.id))
      setFilteredTreeCompany(filteredTree)
      if (filteredTree.length > 0) {
        setStateData(filteredTree[0])
        setSelectedId(filteredTree[0].id)
      }
    } else {
      setFilteredTreeCompany(tree)
      if (tree.length > 0) {
        setStateData(tree[0])
        setSelectedId(tree[0].id)
      }
    }
  }, [filteredCompanies, tree])

  // get first company ID from tree
  useEffect(() => {
    call_data_from_api()
  }, [selectedId])

  const call_company_results_from_api = async () => {
    await getResultCompanyV2({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setResultscompany([])

          return true
        }
        if (status === 200) {
          setResultscompany(data.result)
        } else {
          setResultscompany([])
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  const call_tree_from_api = async () => {
    await getTreeV3({
      token: token,
      company_id: companyID,
      level: level,
      level_id: level_ID,
      language: language,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setTree([])

          return true
        }
        if (status === 200) {
          setTree(data.result)
          if (statepage === true) {
            setStateData(data.result[0])
            //companyID_getfirstshot = data.result[0].id
            setSelectedId(data.result[0].id)
            //await call_data_from_api()
            // onChangeCompany(data[0].id)
          }
        } else {
          setTree([])
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const call_data_from_api = async () => {
    await getDataGroupORCategoryV2({
      token: token,
      company_id: selectedId,
      level: level,
      level_id: level_ID,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
           setDataproject([])

          return true
        }
        if (status === 200) {
          if (data.length <= 10) {
            setPagination(false)
          } else {
            setPagination(initialState.pagination)
          }
           setDataproject(data.result)
          setStatepage(false)
        } else {
           setDataproject([])
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      call_company_results_from_api()
      call_tree_from_api()
    }
  }, [token, level])

  const onChangeCompany = (value) => {
    getDataGroupORCategoryV2({
      token: token,
      level: 1,
      level_id: 0,
      company_id: parseInt(value),
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setGroupcodelist([])
          return true
        }
        if (status === 200) {
          setGroupcodelist(data.result)
        } else {
          setGroupcodelist([])
          return true
        }
      })
      .catch((error) => {
        setGroupcodelist([])

        console.error(error)
      })
    form2.setFieldsValue({
      group_code: null,
    })
  }

  const [postlevelid, setPostlevelid] = useState(0)

  // Update form3 group_code when dataselect changes in add mode for strategic-imperative
  useEffect(() => {
    if (
      eventdrawer &&
      case_from === 'strategic-imperative' &&
      case_api_call === 'create' &&
      dataselect.project_group_code
    ) {
      const groupCodeValue =
        dataselect.project_group_code +
        ' ' +
        (dataselect.project_group_name_en || dataselect.project_group_name || '')
      form3.setFieldsValue({
        group_code: groupCodeValue,
      })
    }
  }, [dataselect, eventdrawer])

  const call_by_select = async (levelid) => {
    let checkLevel = 0
    let idInitial_ID = 0
    let iniCompany_ID = 0
    if (dataselect.length == 0) {
      checkLevel = stateData.level
      idInitial_ID = stateData.id
      iniCompany_ID = stateData.id
    } else {
      idInitial_ID = dataselect.id
      checkLevel = dataselect.level
      iniCompany_ID = dataselect.company_id
    }
    let tree_level = 0
    let tree_company = 0
    let tree_levelID = 0
    if (checkLevel === 0) {
      tree_company = idInitial_ID
      tree_levelID = 0
      tree_level = 1
    } else if (checkLevel === 1) {
      tree_company = iniCompany_ID
      tree_level = 2
      tree_levelID = idInitial_ID
      setPostlevelid(idInitial_ID)
    } else if (checkLevel === 2) {
      // เมื่อคลิก node level 2 ให้เรียก level 3
      await getDataGroupORCategoryV2({
        token: token,
        company_id: iniCompany_ID,
        level: 3,
        level_id: idInitial_ID,
      })
        .then(async (response) => {
          const { status, data, error } = response
          if (error) {
            setDataproject([])
            return true
          }
          if (status === 200) {
            if (data.length <= 10) {
              setPagination(false)
            } else {
              setPagination(initialState.pagination)
            }
            setDataproject(data.result)
          } else {
            setDataproject([])
            return true
          }
        })
        .catch((error) => {
          console.error(error)
        })
      return
    }
    await getDataGroupORCategoryV2({
      token: token,
      level: tree_level,
      level_id: tree_levelID,
      company_id: tree_company,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataproject([])
          return true
        }
        if (status === 200) {
          if (data.length <= 10) {
            setPagination(false)
          } else {
            setPagination(initialState.pagination)
          }
          setDataproject(data.result)
          data.map((item, index) => {
            if (index == 0) {
              group_Create_category_code = item.category_code
            }
          })
        } else {
          setDataproject([])
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  useEffect(async () => {
    if (token) {
      await call_by_select()

      if (dataselect.level === 0) {
        setSelecttable('group')
        onChangeCompany(dataselect.id)
      } else if (dataselect.level === 1) {
        setSelecttable('category')
      } else if (dataselect.level === 2) {
        setSelecttable('strategic-imperative')
      }
      setStateID(dataselect.id)
    }
  }, [dataselect])
  const dataSourceGroup = dataproject.map((item) => ({
    company: item.company_code ?? '',
    group_code: item.code ?? '',
    local_name: item.name ?? '',
    english_name: item.name_en ?? '',
    create_date: moment(item.created_at).format('L'),
    status: item.status ?? '',
    data: item,
  }))

  const dataSourceCategory = dataproject.map((item) => ({
    company: item.company_code ?? '',
    group_code: item.group_code ?? '',
    category_code: item.code ?? '',
    local_name: item.name ?? '',
    english_name: item.name_en ?? '',
    create_date: moment(item.created_at).format('L'),
    status: item.status ?? '',
    data: item,
  }))

  let dataSourceImperative = []
  if (selecttable === 'strategic-imperative') {
    dataSourceImperative = dataproject.map((item) => ({
      company: item.company_code ?? '',
      group_code: item.project_group_code ?? '',
      category_code: item.project_category_code ?? '',
      imperative_code: item.imperative_id ?? '',
      local_name: item.imperative_name ?? '',
      english_name: item.imperative_name_en ?? '',
      status: item.status ?? '',
      data: item,
    }))
  }

  function onChange(pagination2, filters, sorter, extra) {
    if (pagination != false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
    }
  }
  const [datagodelete, setDatagodelete] = useState()
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            className="mini-search-btn-admin"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          >
            <SearchOutlined className="icon" />
            {word['Search']}
          </Button>
          <Button
            type="primary"
            className="mini-search-btn-admin-reset"
            onClick={() => handleReset(clearFilters)}
          >
            {word['Reset']}
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',

    render: (text) => (searchedColumn === dataIndex ? text : text),
  })
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()

    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const renderDrawer = async (value, event, case_drawer, data_edit, levelid) => {
    case_from = case_drawer
    case_api_call = event
    setDatagodelete(data_edit)
    setErrormessage(true)

    if (levelid) {
      setLevel_ID(levelid)
    }

    let idInner = 0
    if (stateID === undefined) {
      idInner = companyID_getfirstshot
    } else {
      idInner = stateID
    }

    if (event == 'create') {
      setEventdrawer(true)
      setStateModal('add')
      setSwitchValue(true)
      if (case_drawer == 'group') {
        let replacecade_and_name = ''
        resultscompany.map((item) => {
          if (item.id === dataselect.id) {
            replacecade_and_name = item.code + ' ' + item.name_th
            onChangeCompany(item.id)
          }
        })
        form1.setFieldsValue({
          company_code_group: idInner,
          group_code_group: null,
          local_group_name_group: null,
          english_group_name_group: null,
          create_date_group: moment(`${today}`, 'YYYY-MM-DD'),
          create_by_group: infoUser.firstname + ' ' + infoUser.lastname,
        })
        text_title_drawer = 'Add Strategic Perspective'
      } else if (case_drawer == 'category') {
        let cutting_title = dataselect.title.split(' ')
        onChangeCompany(dataselect.company_id)
        form2.setFieldsValue({
          company_code: dataselect.company_id,
          group_code: cutting_title[0],
          category_code: null,
          local_category_name: null,
          english_category_name: null,
          create_date: moment(`${today}`, 'YYYY-MM-DD'),
          create_by: infoUser.firstname + ' ' + infoUser.lastname,
        })
        text_title_drawer = 'Add Strategic Direction'
      } else if (case_drawer == 'strategic-imperative') {
        onChangeCompany(dataselect.company_id)
        // ใช้ project_group_code + project_group_name_en จาก dataselect โดยตรง
        const groupCodeValue = dataselect.project_group_code
          ? dataselect.project_group_code +
            ' ' +
            (dataselect.project_group_name_en || dataselect.project_group_name || '')
          : ''
        // ดึงเฉพาะ code จาก title (ส่วนแรกก่อน space) เช่น "007001 ชื่อ" → "007001"
        const categoryCodeValue = dataselect.title ? dataselect.title.split(' ')[0] : ''
        form3.setFieldsValue({
          company_code: dataselect.company_id,
          group_code: groupCodeValue,
          category_code: categoryCodeValue,
          imperative_code: null,
          local_imperative_name: null,
          english_imperative_name: null,
          create_date: moment(`${today}`, 'YYYY-MM-DD'),
          create_by: infoUser.firstname + ' ' + infoUser.lastname,
        })
        text_title_drawer = 'Add Strategic Imperative'
      }
    }
    // ############################### space create or edit @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
    else if (event == 'edit') {
      setEventdrawer(false)
      setStateModal('edit')
      setSwitchValue(data_edit.status == "Active")
      permissionPage.update ? setDisablePage(false) : setDisablePage(true)
      if (case_drawer == 'group') {
        form1.setFieldsValue({
          company_code_group: data_edit.company_id,
          group_code_group: data_edit.code,
          local_group_name_group: data_edit.name,
          english_group_name_group: data_edit.name_en,
          create_date_group: moment(`${today}`, 'YYYY-MM-DD'),
          create_by_group: data_edit.account_name,
        })
        text_title_drawer = 'Edit Strategic Perspective'
      } else if (case_drawer == 'category') {
        onChangeCompany(data_edit.company_id)

        form2.setFieldsValue({
          company_code: dataselect.company_id,
          group_code: data_edit.group_code,
          category_code: data_edit.code,
          local_category_name: data_edit.name,
          english_category_name: data_edit.name_en,
          create_date: moment(`${data_edit.created_at}`, 'YYYY-MM-DD'),
          create_by: data_edit.account_name,
        })
        text_title_drawer = 'Edit Strategic Direction'
      } else if (case_drawer == 'strategic-imperative') {
        onChangeCompany(data_edit.company_id)
        // แสดง project_group_code + project_group_name_en
        const editGroupCodeValue = data_edit.project_group_code
          ? data_edit.project_group_code +
            ' ' +
            (dataselect.project_group_name_en || dataselect.project_group_name || '')
          : data_edit.project_group_code
        form3.setFieldsValue({
          company_code: dataselect.company_id,
          group_code: editGroupCodeValue,
          category_code: dataselect.title
            ? dataselect.title.split(' ')[0]
            : data_edit.project_category_code,
          imperative_code: data_edit.imperative_id,
          local_imperative_name: data_edit.imperative_name,
          english_imperative_name: data_edit.imperative_name_en,
          create_date: moment(`${data_edit.created_at}`, 'YYYY-MM-DD'),
          create_by: data_edit.account.fist_name + ' ' + data_edit.account.last_name,
        })
        text_title_drawer = 'Edit Strategic Imperative'
      }
    }

    if (value === true) {
      setDrawer(true)
    } else {
      setDrawer(false)
    }
  }

  const columns_group = [
    {
      title: <h5>Business</h5>,
      dataIndex: 'company',
    },
    {
      title: <h5>{word['Group_code']}</h5>,
      dataIndex: 'group_code',
      sorter: (a, b) => compareText(a.group_code, b.group_code),
      ...getColumnSearchProps('perspective code'),
    },
    {
      title: <h5>{word['Local_name']}</h5>,
      dataIndex: 'local_name',
      sorter: (a, b) => compareText(a.local_name, b.local_name),
      ellipsis: true,
      ...getColumnSearchProps('local name'),
    },
    {
      title: <h5>{word['English_name']}</h5>,
      dataIndex: 'english_name',
      sorter: (a, b) => compareText(a.english_name, b.english_name),
      ellipsis: true,
      ...getColumnSearchProps('english name'),
    },
    {
      title: <h5>Status</h5>,
      dataIndex: 'status',
      width: 180,
      // render: (_, record) => <span>{record.data.status}</span>,
      sorter: (a, b) => compareText(a.status, b.status),
      ellipsis: true,
      ...getColumnSearchProps('status'),
    },
  ]
  const columns_strategic_imperative = [
    {
      title: <h5>Business</h5>,
      dataIndex: 'company',
    },
    {
      title: <h5>{word['Group_code']}</h5>,
      dataIndex: 'group_code',
    },
    {
      title: <h5>{word['Category_code']}</h5>,
      dataIndex: 'category_code',
      sorter: (a, b) => compareText(a.category_code, b.category_code),
      ...getColumnSearchProps('category_code'),
    },
    {
      title: <h5>{word['Imperative_code']}</h5>,
      dataIndex: 'imperative_code',
      sorter: (a, b) => compareText(a.imperative_code, b.imperative_code),
      ellipsis: true,
      ...getColumnSearchProps('imperative_code'),
    },
    {
      title: <h5>{word['Local_name']}</h5>,
      dataIndex: 'local_name',
      sorter: (a, b) => compareText(a.local_name, b.local_name),
      ellipsis: true,
      ...getColumnSearchProps('local_name'),
    },
    {
      title: <h5>{word['English_name']}</h5>,
      dataIndex: 'english_name',
      sorter: (a, b) => compareText(a.english_name, b.english_name),
      ellipsis: true,
      ...getColumnSearchProps('english_name'),
    },
    {
      title: <h5>Status</h5>,
      dataIndex: 'status',
      width: 120,
      // render: (_, record) => <span>{record.data.status}</span>,
      sorter: (a, b) => compareText(a.status, b.status),
      ellipsis: true,
      ...getColumnSearchProps('status'),
    },
  ]
  const columns_category = [
    {
      title: <h5>Business</h5>,
      dataIndex: 'company',
    },
    {
      title: <h5>{word['Group_code']}</h5>,
      dataIndex: 'group_code',
    },
    {
      title: <h5>{word['Category_code']}</h5>,
      dataIndex: 'category_code',
      sorter: (a, b) => compareText(a.category_code, b.category_code),
      ...getColumnSearchProps('category_code'),
    },
    {
      title: <h5>{word['Local_name']}</h5>,
      dataIndex: 'local_name',
      sorter: (a, b) => compareText(a.local_name, b.local_name),
      ellipsis: true,
      ...getColumnSearchProps('local_name'),
    },
    {
      title: <h5>{word['English_name']}</h5>,
      dataIndex: 'english_name',
      sorter: (a, b) => compareText(a.english_name, b.english_name),
      ellipsis: true,
      ...getColumnSearchProps('english_name'),
    },
    {
      title: <h5>Status</h5>,
      dataIndex: 'status',
      width: 180,
      // render: (_, record) => <span>{record.data.status}</span>,
      sorter: (a, b) => compareText(a.status, b.status),
      ellipsis: true,
      ...getColumnSearchProps('status'),
    },
  ]

  const [dataupdate, setDataupdate] = useState()
  const EditrowtableDATA = async (record, table) => {
    if (table === 'group') {
      renderDrawer(true, 'edit', 'group', record.data, level_ID)
    } else if (table === 'category') {
      renderDrawer(true, 'edit', 'category', record.data, level_ID)
    } else if (table === 'strategic-imperative') {
      renderDrawer(true, 'edit', 'strategic-imperative', record.data, level_ID)
    }
    setDataupdate(record)
  }

  const onFinishGroup = async (values) => {
    let cutname_sTring = ''
    resultscompany.map((item) => {
      if (item.id === values.company_code_group) {
        cutname_sTring = item.code
      }
    })
    if (case_api_call === 'create') {
      const inColeData = {
        company_id: values.company_code_group,
        code: values.group_code_group,
        name: values.local_group_name_group,
        name_en: values.english_group_name_group,
        level: 1,
        level_id: 0,
        status: switchValue
      }
      Godatabase('create', inColeData)
    } else if (case_api_call === 'edit') {
      let cut_string_code = values.group_code_group.split(' ')
      const inColeData = {
        id: dataupdate.data.id,
        company_id: values.company_code_group,
        code: cut_string_code[0],
        name: values.local_group_name_group,
        name_en: values.english_group_name_group,
        level: 1,
        level_id: 0,
        status: switchValue
      }
      Godatabase('edit', inColeData)
    }
  }
  const Godatabase = (type, data) => {
    if (type === 'create') {
      try {
        postDataGroupORCategory({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setDrawer(false)
            call_tree_from_api()
            call_by_select()
            onChangeCompany(data.company_id)
            setErrormessage(true)
          } else {
            if (res.data.errorCode === '2008') {
              setWordERR('Perspective code already exists')
            } else {
              setWordERR('not case')
            }
            setErrormessage(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (type === 'edit') {
      try {
        putDataGroupORCategory({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setDrawer(false)
            call_tree_from_api()
            call_by_select()
            setErrormessage(true)
          } else {
            if (res.data.errorCode === '2018') {
              setWordERR('Group  cannot transfer because it’s connected to project')
            } else if (res.data.errorCode === '2008') {
              setWordERR('Perspective code already exists')
            } else {
              setWordERR('not case')
            }
            setErrormessage(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  const Godatabase2 = (type, data) => {
    if (type === 'create') {
      try {
        postDataGroupORCategory({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setDrawer(false)
            call_tree_from_api()
            call_by_select()
            setErrormessage(true)
          } else {
            if (res.data.errorCode === '2008') {
              setWordERR('Direction code already exists')
            } else {
              setWordERR('not case')
            }

            setErrormessage(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (type === 'edit') {
      try {
        putDataGroupORCategory({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setDrawer(false)
            call_tree_from_api()
            call_by_select()
            setErrormessage(true)
          } else {
            if (res.data.errorCode === '2018') {
              setWordERR('Category cannot transfer because it’s connected to project')
            } else if (res.data.errorCode === '2008') {
              setWordERR('Category code already exists')
            } else {
              setWordERR('not case')
            }
            setErrormessage(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const onFinishCategory = (values) => {
    if (case_api_call === 'create' && case_from === 'strategic-imperative') {
      // Get project_category_id from dataselect
      const payload = {
        name_th: values.local_imperative_name,
        name_en: values.english_imperative_name,
        project_category_id: dataselect.id,
        status: switchValue
      }
      // Call API to save Strategic Imperative
      saveStrategicImperative({
        params: payload,
        token: token,
      })
        .then((res) => {
          if (res.status === 200) {
            setDrawer(false)
            call_tree_from_api()
            call_by_select()
            setErrormessage(true)
            setImperativeForm({
              imperative_code: '',
              local_imperative_name: '',
              english_imperative_name: '',
            })
          } else {
            setWordERR('Failed to save Strategic Imperative')
            setErrormessage(false)
          }
        })
        .catch((error) => {
          console.error(error)
          setWordERR('Error saving Strategic Imperative')
          setErrormessage(false)
        })
      return
    }
    if (case_api_call === 'edit' && case_from === 'strategic-imperative') {
      const payload = {
        id: dataupdate.data.imperative_id,
        name_th: values.local_imperative_name,
        name_en: values.english_imperative_name,
        project_category_id: dataupdate.data.project_category_id,
        status: switchValue
      }
      updateStrategicImperative({
        params: payload,
        token: token,
      })
        .then((res) => {
          if (res.status === 200) {
            setDrawer(false)
            call_tree_from_api()
            call_by_select()
            setErrormessage(true)
            setImperativeForm({
              imperative_code: '',
              local_imperative_name: '',
              english_imperative_name: '',
            })
          } else {
            setWordERR('Failed to update Strategic Imperative')
            setErrormessage(false)
          }
        })
        .catch((error) => {
          console.error(error)
          setWordERR('Error updating Strategic Imperative')
          setErrormessage(false)
        })
      return
    }
    if (case_api_call === 'create' && case_from !== 'strategic-imperative') {
      let codelevelID = postlevelid
      groupcodelist.map((item) => {
        if (item.code == values.group_code) {
          codelevelID = item.id
        }
      })

      const inColeData = {
        company_id: values.company_code,
        code: values.category_code,
        group_code: values.group_code,
        name: values.local_category_name,
        name_en: values.english_category_name,
        level: 2,
        project_group_id: codelevelID,
        status: switchValue
      }
      Godatabase2('create', inColeData)
    } else if (case_api_call === 'edit') {
      let codelevelID = dataupdate.data.level_id
      groupcodelist.map((item) => {
        if (item.code == values.group_code) {
          codelevelID = item.id
        }
      })
      const inColeData = {
        id: dataupdate.data.id,
        company_id: values.company_code,
        code: values.category_code,
        group_code: values.group_code,
        name: values.local_category_name,
        name_en: values.english_category_name,
        level: 2,
        project_group_id: codelevelID,
        status: switchValue
      }
      Godatabase2('edit', inColeData)
    }
  }

  const onFail = (value) => {}

  const renderbutton_save_from = () => {
    if (case_from === 'group') {
      return (
        <Button
          hidden={permissionPage.update ? false : true}
          className="BTN_Next"
          onClick={form1.submit}
          type="primary"
        >
          {word['Save']}
        </Button>
      )
    } else if (case_from === 'category') {
      return (
        <Button
          hidden={permissionPage.update ? false : true}
          className="BTN_Next"
          onClick={form2.submit}
          type="primary"
        >
          {word['Save']}
        </Button>
      )
    } else if (case_from === 'strategic-imperative') {
      return (
        <Button
          hidden={permissionPage.update ? false : true}
          className="BTN_Next"
          onClick={form3.submit}
          type="primary"
        >
          {word['Save']}
        </Button>
      )
    }
  }

  const onClickDelete = (data) => {
    if (data === 'group') {
      setStateBtnDelete('project_group')
    } else if (data === 'category') {
      setStateBtnDelete('project_cat')
    } else if (data === 'strategic-imperative') {
      setStateBtnDelete('strategic_imperative')
    }
    setVisibleDelete(true)
  }

  const renderbutton_delete_from = () => {
    if (case_from === 'group') {
      return (
        <Button
          className="BTN_Delete_CPF_RED"
          style={{ marginRight: 8 }}
          hidden={eventdrawer ? _ : permissionPage.delete ? false : true}
          onClick={() => onClickDelete(case_from)}
        >
          {word['Delete']}
        </Button>
      )
    } else if (case_from === 'category') {
      return (
        <Button
          className="BTN_Delete_CPF_RED"
          style={{ marginRight: 8 }}
          hidden={eventdrawer ? _ : permissionPage.delete ? false : true}
          onClick={() => onClickDelete(case_from)}
        >
          {word['Delete']}
        </Button>
      )
    } else if (case_from === 'strategic-imperative') {
      return (
        <Button
          className="BTN_Delete_CPF_RED"
          style={{ marginRight: 8 }}
          hidden={eventdrawer ? _ : permissionPage.delete ? false : true}
          onClick={() => onClickDelete(case_from)}
        >
          {word['Delete']}
        </Button>
      )
    }
  }

  const renderButton_Modal = () => {
    if (stateModal === 'add') {
      return renderbutton_save_from()
    } else {
      return (
        <>
          {renderbutton_save_from()}
          {renderbutton_delete_from()}
        </>
      )
    }
  }

  const RenderForm_drawer_follow_case = () => {
    if (case_from === 'group') {
      return (
        <Form
          form={form1}
          layout="vertical"
          onFinish={onFinishGroup}
          onFinishFailed={onFail}
        >
          <fieldset disabled={disablePage} className="disable-page">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="company_code_group"
                  label={<h4>{word['Business_Code']}</h4>}
                  rules={[{ required: true, message: 'please select business ' }]}
                  className="disable-page"
                >
                  <Select
                    showSearch
                    id="select"
                    size="large"
                    onChange={onChangeCompany}
                    placeholder="Business Code"
                    allowClear
                    optionFilterProp="children"
                    disabled={disablePage}
                  >
                    {resultscompany.map((item) => (
                      <Option key={item.id} value={item.id} data={item}>
                        {item.code} {item.name_en}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="group_code_group"
                  label={<h4>{word['Group_Code']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter perspective code',
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Perspective Code"
                    onChange={(e) =>
                      form1.setFieldsValue({
                        group_code_group: e.target.value.replace(/\s/g, ''),
                      })
                    }
                    onKeyUp={(e) =>
                      form1.setFieldsValue({
                        group_code_group: toUpper(e.target.value),
                      })
                    }
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="local_group_name_group"
                  label={<h4>{word['Local_Group_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local perspective name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="Local Perspective Name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="english_group_name_group"
                  label={<h4>{word['English_Group_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english perspective name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="English Perspective Name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  className="disable-page"
                  name="create_by_group"
                  label={<h4>{word['Create_by']}</h4>}
                >
                  <Input size="large" disabled />
                </Form.Item>
                <Form.Item
                  id="status"
                  name="status"
                  // label={<h4>Status</h4>}
                  valuePropName="checked"
                  // initialValue={false}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '8px' }}>Status Active:</span>
                    <Switch
                      checked={switchValue}
                      onChange={(checked) => {
                        // form.setFieldsValue({ status: checked })
                        setSwitchValue(checked)
                      }}
                    />
                  </div>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="disable-page"
                  name="create_date_group"
                  label={<h4>{word['Create_Date']}</h4>}
                >
                  <DatePicker
                    size="large"
                    style={{ width: '100%' }}
                    disabled
                    showToday
                    format={dateFormatList}
                  />
                </Form.Item>
              </Col>
            </Row>
            
          </fieldset>
        </Form>
      )
    } else if (case_from === 'category') {
      return (
        <Form
          layout="vertical"
          form={form2}
          onFinish={onFinishCategory}
          onFinishFailed={onFail}
        >
          <fieldset disabled={disablePage} className="disable-page">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="company_code"
                  label={<h4>{word['Business_Code']}</h4>}
                  rules={[{ required: true, message: 'please select business ' }]}
                >
                  <Select
                    showSearch
                    id="select"
                    size="large"
                    onChange={onChangeCompany}
                    placeholder="placeholder"
                    allowClear
                    optionFilterProp="children"
                    disabled={disablePage}
                  >
                    {resultscompany.map((item) => (
                      <Option key={item.id} value={item.id} data={item}>
                        {item.code} {item.name_en}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="group_code"
                  label={<h4>{word['Group_Code']}</h4>}
                  rules={[{ required: true, message: 'please select perspective ' }]}
                >
                  <Select
                    showSearch
                    id="select"
                    size="large"
                    placeholder="placeholder"
                    allowClear
                    optionFilterProp="children"
                    disabled={disablePage}
                  >
                    {groupcodelist.map((item) => (
                      <Option key={item.id} value={item.code} data={item}>
                        {item.code} {item.name_en}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="category_code"
                  label={<h4>{word['Category_Code']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter direction code',
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="placeholder"
                    onChange={(e) =>
                      form2.setFieldsValue({
                        category_code: e.target.value.replace(/\s/g, ''),
                      })
                    }
                    onKeyUp={(e) =>
                      form2.setFieldsValue({
                        category_code: toUpper(e.target.value),
                      })
                    }
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="local_category_name"
                  label={<h4>{word['Local_Category_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local direction name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="placeholder" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="english_category_name"
                  label={<h4>{word['English_Category_Name']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english direction name',
                    },
                  ]}
                >
                  <Input size="large" placeholder="placeholder" />
                </Form.Item>
              </Col>
              <Col span={12} style={{ marginTop: '6px' }}>
                <Form.Item
                  className="disable-page"
                  name="create_by"
                  label={<h4>{word['Create_by']}</h4>}
                >
                  <Input size="large" disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}  style={{display: 'flex', alignItems: 'center',}}>
              <Col span={12}>
                <Form.Item
                  className="disable-page"
                  name="create_date"
                  label={<h4>{word['Create_Date']}</h4>}
                >
                  <DatePicker size="large" style={{ width: '100%' }} disabled />
                </Form.Item>
              </Col>
              <Col span={12} >
                <Form.Item
                    id="status"
                    name="status"
                    // label={<h4>Status</h4>}
                    valuePropName="checked"
                    // initialValue={false}
                   style={{marginTop: '32px'}}
                  >
                    <div style={{ display: 'flex', alignContent: 'center',  }}>
                      <span style={{ marginRight: '8px', }}>Status Active:</span>
                      <Switch
                        checked={switchValue}
                        onChange={(checked) => {
                          // form.setFieldsValue({ status: checked })
                          setSwitchValue(checked)
                        }}
                      />
                    </div>
                  </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Form>
      )
    } else if (case_from === 'strategic-imperative') {
      return (
        <Form
          layout="vertical"
          form={form3}
          onFinish={onFinishCategory}
          onFinishFailed={onFail}
        >
          <fieldset disabled={disablePage} className="disable-page">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  className="disable-page"
                  name="company_code"
                  label={<h4>{word['Business_Code']}</h4>}
                  rules={[{ required: true, message: 'please select business ' }]}
                >
                  <Select
                    showSearch
                    id="select"
                    size="large"
                    onChange={onChangeCompany}
                    placeholder="please select business"
                    allowClear
                    optionFilterProp="children"
                    disabled={true}
                  >
                    {resultscompany.map((item) => (
                      <Option key={item.id} value={item.id} data={item}>
                        {item.code} {item.name_en}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  className="disable-page"
                  name="group_code"
                  label={<h4>{word['Group_code']}</h4>}
                  rules={[{ required: true, message: 'please select perspective ' }]}
                >
                  <Input
                    disabled={true}
                    size="large"
                    placeholder="please select perspective"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  className="disable-page"
                  name="category_code"
                  label={<h4>{word['Category_code']}</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter direction code',
                    },
                  ]}
                >
                  <Input
                    disabled={true}
                    size="large"
                    placeholder="Please enter direction code"
                    onChange={(e) =>
                      form3.setFieldsValue({
                        category_code: e.target.value.replace(/\s/g, ''),
                      })
                    }
                    onKeyUp={(e) =>
                      form3.setFieldsValue({
                        category_code: toUpper(e.target.value),
                      })
                    }
                    maxLength={10}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="local_imperative_name"
                  label={<h4>Local Imperative Name</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter local imperative name',
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Please enter local imperative name"
                    onChange={(e) => {
                      form3.setFieldsValue({
                        local_imperative_name: e.target.value,
                      })
                      setImperativeForm((prev) => ({
                        ...prev,
                        local_imperative_name: e.target.value,
                      }))
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="english_imperative_name"
                  label={<h4>English Imperative Name</h4>}
                  rules={[
                    {
                      whitespace: true,
                      required: true,
                      message: 'Please enter english imperative name',
                    },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Please enter english imperative name"
                    onChange={(e) => {
                      setImperativeForm((prev) => ({
                        ...prev,
                        english_imperative_name: e.target.value,
                      }))
                    }}
                    onKeyUp={(e) => {
                      setImperativeForm((prev) => ({
                        ...prev,
                        english_imperative_name: toUpper(e.target.value),
                      }))
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ marginTop: '6px' }}>
                <Form.Item
                  className="disable-page"
                  name="create_by"
                  label={<h4>{word['Create_by']}</h4>}
                >
                  <Input size="large" disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16} style={{display: 'flex', alignItems: 'center',}}>
              <Col span={12}>
                <Form.Item
                  className="disable-page"
                  name="create_date"
                  label={<h4>{word['Create_Date']}</h4>}
                >
                  <DatePicker size="large" style={{ width: '100%' }} disabled />
                </Form.Item>
              </Col>
              <Col>
              <Form.Item
                  id="status"
                  name="status"
                  // label={<h4>Status</h4>}
                  valuePropName="checked"
                  style={{marginTop: '32px'}}
                  // initialValue={false}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '8px' }}>Status Active:</span>
                    <Switch
                      checked={switchValue}
                      onChange={(checked) => {
                        // form.setFieldsValue({ status: checked })
                        setSwitchValue(checked)
                      }}
                    />
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </fieldset>
        </Form>
      )
    }
  }

  const RenderTable = () => {
    if (selecttable === 'group') {
      if (dataproject.length > 0) {
        return (
          <div className="space-cont" id="zone-group-opacity">
            <div className="layout-button-add-normal-state">
              <TextTitleBold>{word['Project_Group']}</TextTitleBold>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  hidden={permissionPage.create ? false : true}
                  type="primary"
                  className="BTN_Next"
                  onClick={() => renderDrawer(true, 'create', 'group', '', level_ID)}
                >
                  <PlusOutlined className="Icon-color" />
                  {word['Add_Project_Group']}
                </Button>
                <Button
                  type="primary"
                  style={{ marginLeft: 8 }}
                  className="btn_Secondary2"
                  onClick={() => window.location.reload()}
                >
                  <RedoOutlined className="Icon-color" />
                  {word['Reset']}
                </Button>{' '}
              </div>
            </div>
            <Table
              onRow={(record, rowIndex) => {
                return {
                  onClick: () => EditrowtableDATA(record, 'group'), // click row
                }
              }}
              columns={columns_group}
              dataSource={dataSourceGroup}
              // dataSource={groupdata}
              onChange={onChange}
              showSorterTooltip={false}
              pagination={pagination}
            />
          </div>
        )
      } else {
        return (
          <div className="initialstate-container">
            <img className="initialstate-icon" src={iconInitialState}></img>
            <TextTitleBold>{word['Please_add_project_group']}</TextTitleBold>
            <Button
              type="primary"
              className="btn_Secondary2"
              onClick={() => renderDrawer(true, 'create', 'group', '', level_ID)}
            >
              <PlusOutlined className="Icon-color" />
              {word['Add_Project_Group']}
            </Button>
          </div>
        )
      }
    } else if (selecttable === 'category') {
      if (dataproject.length > 0) {
        return (
          <div className="space-cont" id="zone-group-opacity">
            <div className="layout-button-add-normal-state">
              <TextTitleBold>{word['Project_Category']}</TextTitleBold>
              <div>
                <Button
                  type="primary"
                  className="BTN_Next"
                  onClick={() => renderDrawer(true, 'create', 'category', '', level_ID)}
                  hidden={permissionPage.create ? false : true}
                >
                  <PlusOutlined className="Icon-color" />
                  {word['Add_Project_Category']}
                </Button>
                <Button
                  style={{ marginLeft: 8 }}
                  type="primary"
                  className="btn_Secondary2"
                  onClick={() => ReloadPage()}
                >
                  <RedoOutlined className="Icon-color" />
                  {word['Reset']}
                </Button>
              </div>
            </div>
            <Table
              onRow={(record, rowIndex) => {
                return {
                  onClick: () => EditrowtableDATA(record, 'category'), // click row
                }
              }}
              columns={columns_category}
              dataSource={dataSourceCategory}
              // dataSource={catdata}
              onChange={onChange}
              showSorterTooltip={false}
              pagination={pagination}
            />
          </div>
        )
      } else {
        return (
          <div className="initialstate-container">
            <img className="initialstate-icon" src={iconInitialState}></img>
            <h2>{word['Please_add_project_category']}</h2>
            <Button
              type="primary"
              className="btn_Secondary2"
              onClick={() => renderDrawer(true, 'create', 'category', '', level_ID)}
            >
              <PlusOutlined className="Icon-color" />
              {word['Add_Project_Category']}
            </Button>
          </div>
        )
      }
    } else if (selecttable === 'strategic-imperative') {
      if (dataproject.length > 0) {
        return (
          <div className="space-cont" id="zone-group-opacity">
            <div className="layout-button-add-normal-state">
              <TextTitleBold>{word['Strategic_Imperative']}</TextTitleBold>
              <div>
                <Button
                  type="primary"
                  className="BTN_Next"
                  onClick={() =>
                    renderDrawer(true, 'create', 'strategic-imperative', '', level_ID)
                  }
                  hidden={permissionPage.create ? false : true}
                >
                  <PlusOutlined className="Icon-color" />
                  {word['Add_Strategic_Imperative']}
                </Button>
                <Button
                  style={{ marginLeft: 8 }}
                  type="primary"
                  className="btn_Secondary2"
                  onClick={() => ReloadPage()}
                >
                  <RedoOutlined className="Icon-color" />
                  {word['Reset']}
                </Button>
              </div>
            </div>
            <Table
              onRow={(record, rowIndex) => {
                return {
                  onClick: () => EditrowtableDATA(record, 'strategic-imperative'), // click row
                }
              }}
              columns={columns_strategic_imperative}
              dataSource={dataSourceImperative}
              // dataSource={catdata}
              onChange={onChange}
              showSorterTooltip={false}
              pagination={pagination}
            />
          </div>
        )
      } else {
        return (
          <div className="initialstate-container">
            <img className="initialstate-icon" src={iconInitialState}></img>
            <h2>{word['Please_add_strategic_imperative']}</h2>
            <Button
              type="primary"
              className="BTN_Next"
              onClick={() =>
                renderDrawer(true, 'create', 'strategic-imperative', '', level_ID)
              }
              hidden={permissionPage.create ? false : true}
            >
              <PlusOutlined className="Icon-color" />
              {word['Add_Strategic_Imperative']}
            </Button>
          </div>
        )
      }
    }
  }

  return (
    <GroupContainer>
      <div className="layoutmanagement-git-master">
        <div className="layout-left ">
          <div
            style={{ marginTop: 16, marginBottom: 16, marginLeft: 16, marginRight: 16 }}
          >
            <FilterSearchTree
              dataItems={resultscompany}
              selectedItems={filteredCompanies}
              setSelectedItems={setFilteredCompanies}
              placeholderText="Select Business"
              itemTypeName="Business"
              treeId="project-group-filter-bu"
              customTreeData={(item) => {
                const name = item.name_en || item.name_th || ''
                const title =
                  item.title ||
                  [item.code, name].filter((part) => part && part !== '-').join(' ') ||
                  String(item.id)
                return {
                  title,
                  value: item.id,
                  key: String(item.id),
                }
              }}
              excludeAllID={true}
            />
          </div>
          <Tree
            treeCompany={filteredTreeCompany}
            setLevel_ID={setLevel_ID}
            setLevel={setLevel}
            eventAdd={renderDrawer}
            setCheckByID={setCheckByID}
            setCompanyID={setCompanyID}
            setCheckChangeTable={setCheckChangeTable}
            checkChangeTable={checkChangeTable}
            setSelecttable={setSelecttable}
            setCompanyCallDelete={setCompanyCallDelete}
            setdataSelect={setDataSelect}
          />
        </div>
        <div className="layout-right">
          <div className="anatom-con">{RenderTable()}</div>
        </div>
        <Modal
          title={<TextTitleBold>{text_title_drawer}</TextTitleBold>}
          visible={drawer}
          onCancel={() => renderDrawer(false)}
          className="fix-modal"
          width={'634px'}
          destroyOnClose
          maskClosable={false}
          footer={
            <div
              style={{
                textAlign: 'right',
              }}
            >
              {/* {renderbutton_delete_from()}
              {renderbutton_save_from()} */}
              {renderButton_Modal()}
            </div>
          }
        >
          <div hidden={errormessage} style={{ marginBottom: 10 }}>
            <Alert message={wordERR} type="error" showIcon />
          </div>
          {RenderForm_drawer_follow_case()}{' '}
          <DeleteProjectgroup
            visibleDelete={visibleDelete}
            setVisibleDelete={setVisibleDelete}
            state={stateBtnDelete}
            data={datagodelete}
            renderData={call_tree_from_api}
            callTable={call_by_select}
            setVisibleDrawer={setDrawer}
            setCheckChangeTable={setCheckChangeTable}
          />
        </Modal>
      </div>
    </GroupContainer>
  )
}
export default Group
